
import { Component, Vue, Watch } from "vue-property-decorator";
import router from "@/router";
import RelaySchedule from "@/components/relays/RelaySchedule.vue";
import { Getter } from "vuex-class";
import {getSrc} from "@/utils/misc";

@Component({
    components: {
        RelaySchedule,
    },
})
export default class Relay extends Vue {
    @Getter private currentUser: any;
    private relay: any = null;
    private getSrc: (string) => string = getSrc;

    private mounted() {
        this.reset();
    }

    private reset() {
        if (this.$route.params.id) {
            this.getRelay(this.$route.params.id);
        }
    }

    private getRelay(id) {
        if (this.relay) {
            this.relay.picturePath = null;
        }
        this.$store.dispatch("relays/getById", {id})
            .then(async (relay) => {

                // Update global env companyId with current entity company
                await this.$store.dispatch("changeEnvCompanyId", relay.companyId);

                this.relay = relay;
            }).catch(() => router.push({name: "home"}));
    }
}
